import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";
import {addParamsToUrl} from "@/util";

const pointGroup = new AthubRestResource({server: DCIM_SERVER, resource: 'point-group'});

pointGroup.batchJoin = (groupId, itemIds) => {
    return pointGroup.handlePromise(athubAxios.post(
        addParamsToUrl(`${pointGroup.server}/${pointGroup.resource}/${groupId}/item/batch`, {
            itemIds: itemIds,
        })));
};

pointGroup.invalidate = (groupId) => {
    return pointGroup.handlePromise(athubAxios.put(`${pointGroup.server}/${pointGroup.resource}/${groupId}/invalid`));
};

pointGroup.revalidate = (groupId) => {
    return pointGroup.handlePromise(athubAxios.put(`${pointGroup.server}/${pointGroup.resource}/${groupId}/valid`));
};

pointGroup.findByItemId = (itemId) => {
    return pointGroup.handlePromise(athubAxios.get(`${pointGroup.server}/${pointGroup.resource}/item-id/${itemId}`));
};

export default pointGroup;
